module.exports = __webpack_public_path__ + "img/retail1.f2c05f28.png";